export const engagementSegmentsSegmentIdDownloadSelector = "/engagement/segments/:segment_id/download_selector";
